import { useNavigate } from "react-router-dom";
import { Radar } from "react-chartjs-2";
import { useEffect, useState } from "react";
import StyledButton from "../Components/UI/StyledButton";
import TestApi from "../Api/TestApi";
import ReactLoading from "react-loading";
import RegistrationAnket from "../Components/Modules/Autorization/RegistrationAnket";
import { directus } from "../Api/FetchDirectus";
import {  readItems } from "@directus/sdk";
import CourseBlockInterface from "../Interfaces/CourseBlockInterface";
import CourseListBlock from "../Components/Modules/CourseList/CourseListBlock";

const TestResultPage = () => {
  const navigate = useNavigate();
  const [recomendation, setRecomendation] = useState<string | undefined>("");
  const [courseList, setCourseList] = useState<
    Array<CourseBlockInterface> | Record<string, any>[]
  >([]);
  const [complianceList, setComplianceList] = useState<
    { course_name: string; test_name: string }[] | Record<string, any>[]
  >([]);
  const radarData = JSON.parse(localStorage.getItem("radar_data") || "[]");
  const labels = JSON.parse(localStorage.getItem("radar_labels") || "[]");
  const [loader, setLoader] = useState(false);
  const [openRegistration, setOpenRegistration] = useState(false);
  const optionList = [
    {
      name: "Педагогика и психология физического воспитания и спорта",
      id: "6",
    },
    { name: "Спортивная медицина", id: "3" },
    { name: "Физиология и биохимия мышечной деятельности", id: "7" },
    { name: "Теория и методика физической культуры и спорта", id: "5" },
    { name: "Биомеханика и прикладная кинезиология", id: "4" },
    {
      name: "Менеджмент и экономика в сфере физической культуры и спорта",
      id: "2",
    },
  ];

  const data = {
    labels: labels,
    datasets: [
      {
        data: radarData?.map(
          (item: { category_id: number; category_score: number }) =>
            item.category_score
        ),
        fill: false,
        tension: 0.1,
      },
    ],
  };

  const options = {
    plugins: {
      title: {
        display: false,
      },
      legend: {
        display: false,
      },
    },
  };

  const fetchCourse = async () => {
    try {
      return await directus.request(readItems(`Course`, { limit: -1 }));
    } catch (error: any) {
      sessionStorage.removeItem("token");
      navigate("/");
      return [];
    }
  };

  const fetchCompliance = async () => {
    try {
      return await directus.request(readItems(`compliance`, { limit: -1 }));
    } catch (error: any) {
      sessionStorage.removeItem("token");
      navigate("/");
      return [];
    }
  };

  async function fetchCourseList() {
    setCourseList([...(await fetchCourse())]);
  }

  async function fetchComplianceList() {
    setComplianceList([...(await fetchCompliance())]);
  }

  async function onRestart() {
    const data = {
      sphere: localStorage.getItem("activity") || "",
      position: localStorage.getItem("position") || "",
      competencies: JSON.parse(
        localStorage.getItem("competencies_list") || "{}"
      ),
    };

    setLoader(true);
    const startTest = await TestApi.startTest(data);

    if (startTest.status === 200) {
      localStorage.setItem("question", JSON.stringify(startTest.data));
      localStorage.setItem("session_code", startTest.sessionCode);
      localStorage.setItem(
        "total_question",
        JSON.stringify(startTest.totalQuestions)
      );

      localStorage.removeItem("test_count");
      localStorage.removeItem("radar_data");

      window.scrollTo(0, 0);
      navigate("/intro_test");
    }

    setLoader(false);
  }

  useEffect(() => {
    fetchCourseList();
    fetchComplianceList();
  }, []);

  useEffect(() => {
    let min = radarData.reduce(
      (a: { category_score: number }, b: { category_score: number }) =>
        a.category_score > 0 &&
        b.category_score > 0 &&
        a.category_score < b.category_score
          ? a
          : b
    );

    let item = optionList.find((item) => item.id === min.category_id);

    const foundCompliance = complianceList.find(
      (compliance) => compliance.test_name === item?.name
    );


    if (foundCompliance) {
      setRecomendation(foundCompliance?.course_name);
    } else {
      setRecomendation(item?.name);
    }
  }, [radarData]);

  return (
    <div className="coursesListPage">
      <div className="testResult">
        <h3>Тестирование завершено</h3>
        <div className="resultRadar">
          <Radar data={data} options={options} />
        </div>
        <label className="testResultLabel">
          Вам рекомендовано пройти обучение:
        </label>

        {courseList.map((item, index) => {
          if (item.title === recomendation) {
            return (
              <CourseListBlock
                key={index}
                id={item.id}
                title={item.title}
                description={item.description}
                course_details={item.course_details}
                duration={item.duration}
                hours={item.hours}
                document_name={item.document_name}
                course_video={item.course_video}
                access_type={item.access_type}
                modules={item.modules}
                track_list={item.track_list}
                layout={item.layout}
                background_color={item.background_color}
                background_non_color={item.background_non_color}
                price={item.price}
                suitable={item.suitable}
              />
            );
          }
        })}
        <label className="testResultLabel">
          Так же Вы можете попробовать другие курсы:
        </label>

        <div className="coursesListContent">
          {" "}
          {courseList.map((item, index) => {
            if (item.title !== recomendation) {
              return (
                <CourseListBlock
                  key={index}
                  id={item.id}
                  title={item.title}
                  description={item.description}
                  course_details={item.course_details}
                  duration={item.duration}
                  hours={item.hours}
                  document_name={item.document_name}
                  course_video={item.course_video}
                  access_type={item.access_type}
                  modules={item.modules}
                  track_list={item.track_list}
                  layout={item.layout}
                  background_color={item.background_color}
                  background_non_color={item.background_non_color}
                  price={item.price}
                  suitable={item.suitable}
                />
              );
            }
          })}
        </div>

        <div className="resultButtonsBox">
          {loader ? (
            <ReactLoading
              type="spinningBubbles"
              color="black"
              height={"50px"}
              width={"50px"}
            />
          ) : (
            <StyledButton
              text="ПРОЙТИ ВВОДНОЕ ТЕСТИРОВАНИЕ ЕЩЁ РАЗ"
              onClick={onRestart}
            />
          )}
        </div>
      </div>
      {openRegistration && (
        <RegistrationAnket close={(e: boolean) => setOpenRegistration(e)} />
      )}
    </div>
  );
};

export default TestResultPage;
